module.exports = __webpack_public_path__ + "static/img/title.67bcaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/title.png
// module id = dGZh
// module chunks = 3